module.exports = __webpack_public_path__ + "img/farzana-christopher-33.6df40d04.jpg";